/* SAJAT - WELLPOINT Plan Display
 * VERSION: 1.0.0
 * UPDATED: 2026-09-10
 *
 * Feladat:
 * - Liquid server-side előre rendereli a PRO / PLUS / LITE / NO PLAN blokkokat.
 * - Ez a JS CSAK azt kezeli, melyik blokk legyen látható.
 * - Nem számol árat.
 * - Nem kér le Service terméket.
 * - Nem módosít kosarat.
 */

(() => {
  'use strict';

  const SCRIPT_VERSION = '1.0.0';

  /*
   * true  = Console debug
   * false = nincs normál Console log
   */
  //const CAN_WRITE_CONSOLE_LOG = true;
  const CAN_WRITE_CONSOLE_LOG = false;


  function log(...args) {
    if (CAN_WRITE_CONSOLE_LOG) {
      console.info(...args);
    }
  }


  function normalizePlan(value) {
    return String(value || '')
      .trim()
      .toUpperCase();
  }


  function isKnownPlan(value) {
    const plan = normalizePlan(value);

    return (
      plan === 'PRO' ||
      plan === 'PLUS' ||
      plan === 'LITE' ||
      plan === 'NO PLAN'
    );
  }


  /*
   * ==========================================================
   * Megkeresi a kiválasztott Plan optiont
   * ==========================================================
   */

  function getSelectedPlan(container) {

    const scope =
      container.closest('product-info') ||
      container.closest('.product') ||
      document;


    /*
     * Dawn radio / pill selector
     */

    const checkedInputs =
      scope.querySelectorAll(
        'input[type="radio"]:checked'
      );


    for (const input of checkedInputs) {

      const value =
        normalizePlan(input.value);

      if (isKnownPlan(value)) {
        return value;
      }
    }


    /*
     * Dropdown selector fallback
     */

    const selects =
      scope.querySelectorAll(
        'select'
      );


    for (const select of selects) {

      const value =
        normalizePlan(select.value);

      if (isKnownPlan(value)) {
        return value;
      }
    }


    /*
     * Variant map fallback
     * A snippetben lévő JSON map alapján.
     */

    const mapScript =
      container.querySelector(
        '[data-wellpoint-plan-map]'
      );


    if (mapScript) {

      try {

        const variantMap =
          JSON.parse(
            mapScript.textContent
          );


        const variantInputs =
          scope.querySelectorAll(
            'form[action*="/cart/add"] input[name="id"]'
          );


        for (const input of variantInputs) {

          const variantId =
            String(input.value || '');


          if (
            variantMap[variantId] &&
            isKnownPlan(
              variantMap[variantId]
            )
          ) {

            return normalizePlan(
              variantMap[variantId]
            );
          }
        }

      } catch (error) {

        if (CAN_WRITE_CONSOLE_LOG) {
          console.warn(
            '[WELLPOINT Plan Display] Variant map error:',
            error
          );
        }
      }
    }


    return null;
  }


  /*
   * ==========================================================
   * Látható Plan blokk beállítása
   * ==========================================================
   */

  function showPlan(
    container,
    selectedPlan
  ) {

    const plan =
      normalizePlan(
        selectedPlan
      );


    if (!isKnownPlan(plan)) {
      return;
    }


    const blocks =
      container.querySelectorAll(
        '[data-wp-plan]'
      );


    blocks.forEach(block => {

      const blockPlan =
        normalizePlan(
          block.dataset.wpPlan
        );


      block.hidden =
        blockPlan !== plan;
    });


    log(
      `[WELLPOINT Plan Display] Selected: ${plan}`
    );
  }


  /*
   * ==========================================================
   * Egy Plan-info container frissítése
   * ==========================================================
   */

  function updateContainer(
    container
  ) {

    const selectedPlan =
      getSelectedPlan(
        container
      );


    if (!selectedPlan) {

      log(
        '[WELLPOINT Plan Display] Selected Plan not found.'
      );

      return;
    }


    showPlan(
      container,
      selectedPlan
    );
  }


  /*
   * ==========================================================
   * Összes WELLPOINT Plan blokk frissítése
   * ==========================================================
   */

  function updateAll() {

    document
      .querySelectorAll(
        '[data-wellpoint-plan-info]'
      )
      .forEach(
        updateContainer
      );
  }


  /*
   * ==========================================================
   * Variant változás
   * ==========================================================
   *
   * Kis késleltetést használunk, hogy Dawn előbb
   * frissíthesse a kiválasztott variantot.
   */

  document.addEventListener(
    'change',
    event => {

      const target =
        event.target;


      if (
        !target ||
        !(
          target.matches?.(
            'input[type="radio"]'
          ) ||
          target.matches?.(
            'select'
          )
        )
      ) {
        return;
      }


      setTimeout(
        updateAll,
        50
      );
    },
    true
  );


  /*
   * ==========================================================
   * Dawn / Shopify dinamikus variant frissítés fallback
   * ==========================================================
   */

  document.addEventListener(
    'variant:change',
    () => {

      setTimeout(
        updateAll,
        50
      );
    }
  );


  /*
   * ==========================================================
   * Inicializálás
   * ==========================================================
   */

  function initialize() {

    log(
      `[WELLPOINT Plan Display] v${SCRIPT_VERSION} loaded`
    );


    updateAll();


    log(
      `[WELLPOINT Plan Display] v${SCRIPT_VERSION} ready`
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();
  }

})();

/* EOF SAJAT - WELLPOINT Plan Display */